"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FBASelfServePrepOption = void 0;
exports.FBASelfServePrepOption = {
    SELF_SERVE_FBA_PARCEL_STANDARD: "SELF_SERVE_FBA_PARCEL_STANDARD",
    SELF_SERVE_FBA_FREIGHT_STANDARD: "SELF_SERVE_FBA_FREIGHT_STANDARD",
};
//# sourceMappingURL=fbaself-serve-prep-option.js.map